import { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Loader2, ShieldAlert } from 'lucide-react';

// GO-LIVE #2: "nunca aplicar sin que el admin vea primero el resultado del
// scan" + "confirmación escrita" — the Apply button stays disabled until the
// admin literally types APPLY, on top of already having reviewed the scan.
export function ConfirmApplyDialog({ open, onClose, onConfirm, title, summary, confirming }) {
  const [text, setText] = useState('');
  useEffect(() => { if (open) setText(''); }, [open]);

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md" data-testid="confirm-apply-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-base">
            <ShieldAlert className="w-4.5 h-4.5 text-amber-600" /> {title}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3 text-sm text-gray-600">
          <p>{summary}</p>
          <div className="space-y-1.5">
            <Label className="text-xs text-gray-500">Type APPLY to confirm</Label>
            <Input data-testid="confirm-apply-input" value={text} onChange={(e) => setText(e.target.value)} placeholder="APPLY" autoFocus />
          </div>
        </div>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={onClose} disabled={confirming}>Cancel</Button>
          <Button
            data-testid="confirm-apply-submit-btn"
            onClick={onConfirm}
            disabled={text.trim().toUpperCase() !== 'APPLY' || confirming}
            className="bg-red-600 hover:bg-red-700 text-white"
          >
            {confirming && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
            {confirming ? 'Applying...' : 'Apply'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default ConfirmApplyDialog;
